import React from 'react';
import PropTypes from 'prop-types';

export const Icon = ({ name, color, strokeColor, width, height, size, ...restProps }) => {
	const svgProps = {
		fill: color ? color : '#000000',
		width: width ? width : size,
		height: height ? height : size,
		stroke: strokeColor ? strokeColor : null,
	};

	const renderSvg = () => {
		switch (name) {
			case 'arrow-left':
				return (
					<svg {...svgProps} {...restProps} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M6.96935 3.13799L6.91435 3.19555L0.122711 11.4344C-0.0227242 11.6108 -0.0388851 11.8568 0.0742321 12.0487L0.122711 12.1179L6.91435 20.3567C7.10311 20.5857 7.44175 20.6183 7.67073 20.4295C7.87889 20.2579 7.92476 19.9625 7.78957 19.7381L7.74356 19.6732L1.67785 12.3134H23.4627C23.7594 12.3134 24 12.0729 24 11.7761C24 11.5041 23.7979 11.2793 23.5356 11.2437L23.4627 11.2388H1.67642L7.74356 3.8791C7.91516 3.67094 7.90381 3.37215 7.72829 3.17773L7.67073 3.12273C7.48339 2.96829 7.22263 2.96204 7.03062 3.09028L6.96935 3.13799Z'></path>
					</svg>
				);
			case 'arrow-right':
				return (
					<svg {...svgProps} {...restProps} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M17.0306 3.13799L17.0856 3.19555L23.8773 11.4344C24.0227 11.6108 24.0389 11.8568 23.9258 12.0487L23.8773 12.1179L17.0856 20.3567C16.8969 20.5857 16.5582 20.6183 16.3293 20.4295C16.1211 20.2579 16.0752 19.9625 16.2104 19.7381L16.2564 19.6732L22.3221 12.3134H0.537313C0.240563 12.3134 0 12.0729 0 11.7761C0 11.5041 0.20214 11.2793 0.464403 11.2437L0.537313 11.2388H22.3236L16.2564 3.8791C16.0848 3.67094 16.0962 3.37215 16.2717 3.17773L16.3293 3.12273C16.5166 2.96829 16.7774 2.96204 16.9694 3.09028L17.0306 3.13799Z'></path>
					</svg>
				);
			case 'chevron_down':
				return (
					<svg {...svgProps} {...restProps} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M19.0834 8.15965C19.2909 7.94905 19.6297 7.94648 19.8403 8.15391C20.0318 8.34248 20.0513 8.63969 19.8975 8.8504L19.8461 8.91082L12.3813 16.4898C12.1907 16.6833 11.8897 16.7009 11.679 16.5425L11.6187 16.4898L4.15391 8.91082C3.94648 8.70022 3.94905 8.36134 4.15965 8.15391C4.35111 7.96533 4.64858 7.95032 4.85693 8.10737L4.91657 8.15965L12 15.3506L19.0834 8.15965Z'></path>
					</svg>
				);
			case 'tooltip':
				return (
					<svg {...svgProps} {...restProps} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
						<path d="m0 0h24v24h-24z" fill="none"/>
						<path d="m12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm1 17h-2v-2h2zm2.07-7.75-.9.92c-.72.73-1.17 1.33-1.17 2.83h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" fill="#C6C6C6" />
					</svg>
				)
			case 'circle_check':
				return (
					<svg {...svgProps} {...restProps} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
						<path fillRule="evenodd" clipRule="evenodd"
							d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 8.8174 22.7357 5.76515 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM12 0.96C14.928 0.96 17.7361 2.12314 19.8065 4.19354C21.8769 6.26394 23.04 9.07201 23.04 12C23.04 18.0972 18.0972 23.04 12 23.04C5.90278 23.04 0.96 18.0972 0.96 12C0.96 5.90278 5.90278 0.96 12 0.96ZM16.3136 9.06838C16.126 8.88104 15.8221 8.88123 15.6348 9.0688L10.7962 13.9123L8.3718 11.4818L8.31802 11.4352C8.13027 11.2956 7.86359 11.3108 7.69298 11.481C7.50531 11.6682 7.50496 11.9722 7.6922 12.1598L10.457 14.931L10.5108 14.9776C10.6988 15.1174 10.9659 15.1019 11.1364 14.9312L16.314 9.7472L16.3605 9.69334C16.4998 9.50534 16.4841 9.23868 16.3136 9.06838Z">
						</path>
					</svg>
				)

			case 'delete':
				return (
					<svg {...svgProps} {...restProps} clipRule="evenodd" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 35 37" xmlns="http://www.w3.org/2000/svg">
						<path d="m30.32 17.39v18.26m-6.08-18.26v18.26m-6.08-18.26v18.26m-9.87-23.58h33.42m-11.39 0h-12.16v-4.57h12.16zm6.08 30.43h-24.31v-30.43h24.31z" strokeWidth="1.5" transform="translate(-7.54 -6.75)"/>
					</svg>
				)
			default:
				break;
		}
	};

	return <React.Fragment>{renderSvg()}</React.Fragment>;
};

Icon.propTypes = {
	name: PropTypes.string.isRequired,
	color: PropTypes.string,
	strokeColor: PropTypes.string,
	width: PropTypes.string,
	height: PropTypes.string,
	size: PropTypes.string,
};

export default Icon;
